<template>
  <div class="personalized-banner">
    <img v-if="$props.image" :src="$props.image" :alt="$props.altText">
    <base-button v-if="$props.offerType === 'ADDON_OFFER'" @click="activateOffer" variant="primary">
      {{ $t('common.activate') }}
    </base-button>
    <base-button v-else @click="signUpForOffer" variant="primary">
      {{ $t('common.signUp') }}
    </base-button>
  </div>
</template>

<script>
export default {
  name: 'personalized-banner',
  props: {
    image: {
      type: String
    },
    altText: {
      type: String,
      default: 'Promo image'
    },
    offerType: {
      type: String
    }
  },
  methods: {
    activateOffer () {
      this.$emit('activate-offer')
    },
    signUpForOffer () {
      this.$emit('sign-up-for-offer')
    }
  }
}
</script>

<style scoped lang="scss">
.personalized-banner {
  margin-bottom: 2.4rem;

  @media (map_get($breakpoints, exsm)) {
    flex-basis: calc(100% / 2 - 1.6rem);
    max-width: calc(100% / 2 - 1.6rem);
    margin: 0 .8rem 2.4rem;
  }

  @media (map_get($breakpoints, lg)) {
    flex-basis: calc(100% / 3 - 1.6rem);
    max-width: calc(100% / 3 - 1.6rem);
  }

  .base-button {
    margin-top: .4rem;
    width: 100%;
  }
}
</style>
